/**
 *  메인 알림 카드
 *
 *  @author  Bruce.Cheong   2026-04-30
 *
 */





/** External Imports */
import { Fragment } from "react";

/** Internal Imports */
import CSS from "./MainAlert.module.css";
import CardContainer from "../../../Component/Elements/CardContainer/CardContainer";





interface MainAlertProps {
    user?: {
        name?: string;
    };
    messageText?: string[];
    data?: {
        scheduleAfter?: Record<string, any>[];
        scheduleBefore?: Record<string, any>[];
        notiList?: Record<string, any>[];
        shootPhotoList?: Record<string, any>[];
        photoSelectList?: Record<string, any>[];
    };
}

export function MainAlert(iProps : MainAlertProps) {

    // /** 스케줄 fetchData (다음일정) */
    // iProps.data.scheduleAfter
    // /** 스케줄 fetchData (지난일정) */
    // iProps.data.scheduleBefore
    // /** 알림 fetchData */
    // iProps.data.notiList
    // /** 촬영사진 fetchData */
    // iProps.data.shootPhotoList
    // /** 사진선택 fetchData */
    // iProps.data.photoSelectList

    const messageText = iProps.messageText ?? [
        "스튜디오와의 멋진 만남을 기대합니다.",
        "스케줄이 배정되면 이곳에서 안내해 드릴게요."
    ];


    // 스케줄 (다음일정) 이 있으면 며칠 후 촬영이 있다고 안내하는 메시지 표시







    return <CardContainer class_name_list={[CSS.MainAlert]}>
        <h3 className={CSS.Title}>
            {iProps?.user?.name || "ㅇㅇ"} 고객님, 환영합니다! 👋
        </h3>
        <p className={CSS.Description}>
            {messageText.map((iText, index) => (
                <Fragment key={`${index}-${iText}`}>
                    {index > 0 && <br />}
                    {iText}
                </Fragment>
            ))}
        </p>
    </CardContainer>;
}
